import type { UniclientAction } from '@lemonade-hq/uniclient-chat';
import type { TextVariants } from '@lemonade-hq/uniclient-theme';
import { baseButton, Text, WrapWithTooltipIfOverflowing } from '@lemonade-hq/uniclient-theme';
import { clsx } from 'clsx';
import { motion } from 'motion/react';
import { getTextFadeDelay } from '../../animationHelpers';
import type { AnimationProgressProps, BaseProgressItemProps } from '../../types';
import * as styles from './ItemTitle.css';

interface ItemTitleProps
  extends Pick<BaseProgressItemProps, 'completed' | 'current'>,
    Pick<AnimationProgressProps, 'isBackwards' | 'isExpanding' | 'level'> {
  readonly title: string;
  readonly type: NonNullable<TextVariants>['type'];
  readonly action?: UniclientAction;
  readonly onAction?: (action: UniclientAction) => Promise<unknown>;
  readonly isDisabled?: boolean;
}

export const ItemTitle: React.FC<ItemTitleProps> = ({
  title,
  type,
  onAction,
  action,
  current,
  completed,
  isBackwards,
  isExpanding,
  level,
  isDisabled,
}) => {
  const hasAction = action != null && onAction != null && !isDisabled;
  const isBold = type === 'h6';

  return (
    <WrapWithTooltipIfOverflowing content={title}>
      <Text
        animate={{
          transition: {
            delay: getTextFadeDelay({
              level,
              isExpanding,
              isBackwards,
              previousSubItemHasSubSubItems: false,
            }),
          },
        }}
        // @ts-expect-error motion types
        as={type === 'h6' ? motion.h6 : motion.p}
        className={clsx(hasAction ? baseButton : '', styles.title({ isBold }))}
        color={isDisabled ? '$textDisabled' : level === 1 || completed || current ? '$textPrimary' : '$textSecondary'}
        data-active={current}
        layout
        onClick={() => hasAction && void onAction(action)}
        type={type}
      >
        {title}
      </Text>
    </WrapWithTooltipIfOverflowing>
  );
};
